import React, { useRef } from 'react';
import Image from 'next/image';
import styles from './styles.module.css';
import { useClickOutside } from 'hooks/useClickOutside';

interface ImageModalProps {
  isOpen: boolean;
  imageUrl: string;
  onClose: () => void;
}

export const ImageModal = ({ isOpen, imageUrl, onClose }: ImageModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  useClickOutside({ onClick: onClose, ref: modalRef });

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} ref={modalRef}>
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>
        <Image
          fill
          unoptimized
          src={imageUrl}
          alt="Full size"
          className={styles.fullSizeImage}
          sizes="90vw"
        />
      </div>
    </div>
  );
};
